var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yiqux-app",attrs:{"id":"app"}},[_c('AppFirstScreen'),_c('AppSecondScreen'),_c('AppThirdScreen'),_c('AppFourthScreen'),_c('AppBottomScreen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }